export function selectAllUsers(state) {
  return state.allUsers;
}
